import React, { useEffect, useState } from 'react';
import { Text } from '@chakra-ui/react';
import { ObjectText } from '../../../types/ObjectTypes';
import TextTruncate from 'react-text-truncate';
import { getTextByMarkType } from '../../../services/Object/ObjectTextsDataService';

export interface ShortDescriptionProps {
  textsData: Array<ObjectText>;
}

export const ShortDescription = (props: ShortDescriptionProps): JSX.Element => {
  const { textsData } = props;
  const [shortDescription, setShortDescription] = useState<string>();

  useEffect(() => {
    const description = getTextByMarkType(textsData, 'M1');
    setShortDescription(
      description.replace(/(<([^>]+)>)/gi, ''),
    );
  }, [textsData]);

  return (
    <Text h={'auto'} fontSize={'sm'} as={'div'} color={'gray.500'} textAlign={'justify'}>
      <TextTruncate line={4} text={shortDescription} truncateText={'...'} />
    </Text>
  );
};
